<p-inputGroup>
    <input
        pInputText
        type="email"
        [attr.data-testid]="getDataTestId()"
        [formControl]="formControl"
        [placeholder]="props.placeholder"
    />
    <p-button [icon]="props.icon" [disabled]="!formControl?.value" (onClick)="btnClick($event)" />
</p-inputGroup>
